import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { Button } from '../Button/Button';

type Props = {
  text: string;
  maxLength?: number;
  label: React.ReactNode;
  textMarginLeft?: number;
};

const getDisplayedText = (text: string, expanded: boolean, maxLength: number) => {
  if (expanded || text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
};

export const ShowMore = ({ text, maxLength = 100, label, textMarginLeft = 0 }: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box whiteSpace="pre-wrap">
      {label}
      <Box ml={textMarginLeft}>
        <Typography>{getDisplayedText(text || '-', expanded, maxLength)}</Typography>
        {text && text.length > maxLength ? (
          <Button
            variant="text"
            onClick={() => setExpanded(!expanded)}
            endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          >
            {!expanded ? 'Show more' : 'Hide'}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
